export const LOCALES = ['en', 'nl'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';
export const LOCALE_COOKIE = 'tcgsecret-locale';

/**
 * Runs before the page paints. Pages are built in English; for Dutch visitors this hides the page
 * until React has switched to Dutch, so the English text never flashes.
 */
export const LOCALE_DETECT_SCRIPT = `(function(){try{var m=document.cookie.match(/(?:^|; )${LOCALE_COOKIE}=([^;]+)/);var l=m?m[1]:((navigator.language||'').toLowerCase().indexOf('nl')===0?'nl':'en');if(l==='nl'){var d=document.documentElement;d.lang='nl';d.classList.add('locale-pending');setTimeout(function(){d.classList.remove('locale-pending')},2500)}}catch(e){}})();`;

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

export function formatPrice(price: number, locale: Locale) {
  return new Intl.NumberFormat(locale === 'nl' ? 'nl-NL' : 'en-IE', { style: 'currency', currency: 'EUR' }).format(price);
}

export function formatDate(isoDate: string, locale: Locale) {
  return new Intl.DateTimeFormat(locale === 'nl' ? 'nl-NL' : 'en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(
    new Date(`${isoDate}T12:00:00Z`)
  );
}
